import { DIMENSION, COLORS } from './constants';

export function ArrowMarkers() {
  const { arrowLength, arrowWidth } = DIMENSION;

  return (
    <defs>
      {/* Filled arrow start (for dimension lines) */}
      <marker
        id="dim-arrow-start"
        viewBox={`0 0 ${arrowLength} ${arrowWidth * 2}`}
        refX={arrowLength}
        refY={arrowWidth}
        markerWidth={arrowLength}
        markerHeight={arrowWidth * 2}
        orient="auto-start-reverse"
      >
        <polygon
          points={`${arrowLength},0 0,${arrowWidth} ${arrowLength},${arrowWidth * 2}`}
          fill={COLORS.dimension}
        />
      </marker>
      {/* Filled arrow end (for dimension lines) */}
      <marker
        id="dim-arrow-end"
        viewBox={`0 0 ${arrowLength} ${arrowWidth * 2}`}
        refX={0}
        refY={arrowWidth}
        markerWidth={arrowLength}
        markerHeight={arrowWidth * 2}
        orient="auto"
      >
        <polygon
          points={`0,0 ${arrowLength},${arrowWidth} 0,${arrowWidth * 2}`}
          fill={COLORS.dimension}
        />
      </marker>

      {/* Open arrowhead for leader lines */}
      <marker
        id="leader-arrow"
        viewBox={`0 0 ${arrowLength} ${arrowWidth * 2}`}
        refX={0}
        refY={arrowWidth}
        markerWidth={arrowLength}
        markerHeight={arrowWidth * 2}
        orient="auto"
      >
        <polyline
          points={`0,0 ${arrowLength},${arrowWidth} 0,${arrowWidth * 2}`}
          fill="none"
          stroke={COLORS.dimension}
          strokeWidth={0.3}
        />
      </marker>

      {/* Center dot marker */}
      <marker
        id="center-dot"
        viewBox="0 0 4 4"
        refX={2}
        refY={2}
        markerWidth={4}
        markerHeight={4}
      >
        <circle cx={2} cy={2} r={1} fill={COLORS.dimension} />
      </marker>

      {/* Single-direction hatching (45°) */}
      <pattern
        id="hatch-default"
        width="4"
        height="4"
        patternTransform="rotate(45)"
        patternUnits="userSpaceOnUse"
      >
        <line
          x1="0"
          y1="0"
          x2="0"
          y2="4"
          stroke={COLORS.hatch}
          strokeWidth="0.3"
        />
      </pattern>

      {/* Cross-hatching (45° + 135°) for metal sections */}
      <pattern
        id="hatch-cross"
        width="4"
        height="4"
        patternUnits="userSpaceOnUse"
      >
        <line
          x1="0" y1="0" x2="4" y2="4"
          stroke={COLORS.hatch}
          strokeWidth="0.25"
        />
        <line
          x1="4" y1="0" x2="0" y2="4"
          stroke={COLORS.hatch}
          strokeWidth="0.25"
        />
      </pattern>

      {/* Fine hatching (30°) for wood sections */}
      <pattern
        id="hatch-fine"
        width="2.5"
        height="2.5"
        patternTransform="rotate(30)"
        patternUnits="userSpaceOnUse"
      >
        <line
          x1="0"
          y1="0"
          x2="0"
          y2="2.5"
          stroke={COLORS.hatch}
          strokeWidth="0.2"
        />
      </pattern>
    </defs>
  );
}
